import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";
import { xorDecrypt } from "../../encrypt";
import axiosInstance from "../../api/axiosInstance";
import { BASE_API_URL } from "../../constants";

const ManagePassword = () => {
  const [email] = useState(xorDecrypt(localStorage.getItem("username")) || "");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

  const handleRequestResetLink = async () => {
    setLoading(true);
    try {
      await axiosInstance.post(
      `${BASE_API_URL}/reset-password`,
      { email },
      {
        withCredentials: true,
      });
      setSnackbar({ open: true, message: "Reset link sent to your email!", severity: "success" });
    } catch {
      setSnackbar({ open: true, message: "Failed to send reset link.", severity: "error" });
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "20px",
        position: "relative"
      }}
    >
      {/* Title in Top-Left Corner */}
      <Typography
        variant="h4"
        sx={{
          background: "linear-gradient(45deg, #ffa500, #ffffff, #ffa500)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: "bold",
          alighSelf: "flex-start",
          position: "absolute",
          top: "30px",
          left: "40px",
          textAlign: "left",
         
        }}
      >
        Manage Password
      </Typography>

      {/* Centered Content */}
      <Box
        sx={{
          display: "flex",
          marginTop:"100px",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center",
        }}
      >
        <TextField
          fullWidth
          label="Email"
          value={email}
          disabled
          InputLabelProps={{
            sx: {
              color: "white !important", // Ensures label text is white
              "&.Mui-focused": {
                color: "white !important", // Keeps it white when focused
              },
              "&.MuiInputLabel-root": {
                color: "white !important", // Ensures it applies correctly
              },
            },
          }}
          InputProps={{
            sx: {
              backgroundColor: "rgba(149, 148, 147, 0.71) !important", // Bright semi-transparent background
              borderRadius: "8px", // Rounded corners for a smooth look
              color: "white !important", // Input text stays white
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white !important", // White border
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white !important", // White border on hover
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FFD700 !important", // Gold border when focused
              },
              "& input": {
                color: "white !important", // Ensure input text remains white
              },
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#FF9800 !important", // White border
      },
      "&:hover fieldset": {
        borderColor: "#FF9800 !important", // White border on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#FF9800 !important", // White border when focused
      },},
          }}
        />

        {/* Send Reset Link Button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FF9800",
            color: "white",
            "&:hover": { backgroundColor: "#E68900" },
            width: "350px",
            padding: "10px",
            borderRadius: "8px",
            marginTop: "20px",
          }}
          onClick={handleRequestResetLink}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : "Send Reset Link"}
        </Button>
      </Box>

      {/* Snackbar for feedback messages */}
      <Snackbar open={snackbar.open} 
      autoHideDuration={3000} 
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default ManagePassword;
